import {Route, Routes} from "react-router-dom";
import React from "react";
import EquipmentTitleNavigator from "../component/equipment/EquipmentTitleNavigator";
import {useTranslation} from "react-i18next";
import {EquipmentTab} from "../component/equipment/EquipmentTab";
import {EquipmentKitTab} from "../component/equipment/equipmentKit";
import SectionHeader from "../../../util/component/SectionHeader";

const EquipmentPage = () => {
    const {t} = useTranslation(["operation"]);
    return (
        <>
            <SectionHeader
                title={t("vehicleEquipment.pageTitles.mainTitleVehicle") + " " + t("vehicleEquipment.pageTitles.mainTitleEquipment")}
            />
            <EquipmentTitleNavigator/>
            <>
                <Routes>
                    <Route path="/" element={<EquipmentTab/>}/>
                    <Route path="/kit" element={<EquipmentKitTab/>}/>
                </Routes>
            </>
        </>
    );
};

export default EquipmentPage;
